<template>

  <form id="addCopyTemplate" @submit.prevent="submitForm">
    <div class="steps-w" v-if="filteredSteps.length > 0">
      <div class="step-triggers">
        <a :class="{ 'active': step.key == currentStep.key, 'step-trigger': 1==1}" v-for="step in filteredSteps" @click="customStep(step.key)">{{step.name}}</a>
      </div>
      <div class="step-contents">

        <CopyTemplateSteps :currentStep="currentStep" :channels="channels" :categories="categories" :headers="headers" @headerInterface="onRemoveHeader" :templateData="templateData" />

        <div class="form-buttons-w text-right">
          <button class="btn btn-primary" @click.prevent="previousStep" v-if="currentStep.index > 1">Previous</button>

          <button class="btn btn-primary" @click.prevent="nextStep" v-if="currentStep.index < filteredSteps.length">Continue</button>
          <button class="btn btn-primary" type="submit" v-else-if="currentStep.index == filteredSteps.length">Submit</button>
          <button class="btn btn-primary" v-else></button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import CopyTemplateSteps from './Steps/CopyTemplateSteps'
import FormMixin from '@/mixins/forms.js'

export default {
  mixins: [FormMixin],
  props: ['session-type', 'channels', 'categories', 'headers', 'templateData'],
  components: { CopyTemplateSteps },
  data () {
    return {
      steps: [
        { name: 'Rule', key: 'copytemplate-rule', group: 'copytemplate' },
        { name: 'Headers', key: 'copytemplate-headers', group: 'copytemplate' }
        // { 'name': 'Notes', 'key': 'photodesk-notes', 'group': 'photodesk' }
      ],
      filteredSteps: [],
      currentStep: {
        key: '',
        index: 0
      }
    }
  },
  mounted () {
    this.initializeSteps()
  },
  methods: {
    initializeSteps () {
      var self = this
      var index = 1
      const filter = self.steps
        .filter(step => {
          if (
            step.group !=
            self.sessionType.slice(0, self.sessionType.indexOf('-'))
          ) {
            return false
          }
          return true
        })
        .map(step => {
          step.index = index
          index++
          return step
        })
      self.filteredSteps = filter

      self.currentStep.key = self.filteredSteps[0].key
      self.currentStep.index = 1
      self.$store.dispatch('updateLoading', 'false')
    },
    previousStep () {
      var self = this
      let step = self.filteredSteps.find(
        filter => parseInt(filter.index) === this.currentStep.index - 1
      )

      this.currentStep.index--
      this.currentStep.key = step.key
      this.onStepChange()
    },
    nextStep () {
      var self = this

      let step = self.filteredSteps.find(
        filter => parseInt(filter.index) === this.currentStep.index + 1
      )
      this.currentStep.index++
      this.currentStep.key = step.key
      this.onStepChange()
    },
    customStep (key) {
      var self = this

      let step = self.filteredSteps.find(filter => filter.key === key)
      this.currentStep.index = step.index
      this.currentStep.key = step.key
      this.onStepChange()
    },
    submitForm () {
      if (this.sessionType == 'copytemplate-add') {
        this.submitCopyTemplateFormAdd()
      }
      if (this.sessionType == 'copytemplate-update') {
        this.submitCopyTemplateFormUpdate()
      }
    },
    onStepChange (step) {
      if (this.currentStep.key == 'copytemplate-headers') {
        this.$emit('stepInterface', 'headers')
      } else {
        this.$emit('stepInterface', 'others')
      }
    },
    onRemoveHeader (header) {
      this.$emit('headerInterface', header)
    }
  },
  watch: {}
}
</script>

<style scoped>
.step-contents {
  height: calc(100vh - 300px);
  overflow: auto;
}
</style>
